import React, {ReactNode, Suspense} from "react";
import {useHistory} from 'react-router-dom';
import axios from "axios";
import PageLoading from "components/loading";
import UIUtil from "utils/UIUtils";
import loadingStore from "common/page/store/LoadingStore";

const PasswordContext = React.createContext<boolean>(false);
const PasswordDispatchContext = React.createContext<React.Dispatch<boolean>>(value => {
});

export function PasswordProvider({children}: { children: ReactNode }) {
    const TouchEnNx = window["TouchEnNx"];
    const TouchEnNxConfig = window["TouchEnNxConfig"];
    const useTouchEnnxKey = window["useTouchEnnxKey"];
    const touchenexInfo = window["touchenexInfo"];
    const TOUCHENEX_CHECK = window["TOUCHENEX_CHECK"];
    const TNK_SR = window["TNK_SR"];
    const [task, dispatch] = React.useReducer(tasksReducer, false);
    const history = useHistory();

    const getTNKSR = async () => {
        const response = await axios.post('/nx/NxKeyTNKSR.do', {});
        if (response.status === 200) {
            const responseText = response.data;
            const result = responseText.replaceAll(/(\r\n|\n|\r)/gm, "");

            if (typeof TNK_SR == 'undefined') {
                throw new Error('TNK_SR value is not loaded!!!')
            }
            return result;
        }
    }

    /*
    * TouchEn ex 설치 점검
    */
    const checkTouchEnNx = () => new Promise(resolve => {
        try {
            if (TouchEnNxConfig.use.nxkey && useTouchEnnxKey) {
                TouchEnNx.useModule = [touchenexInfo];
            }
        } catch (e) {
            console.error("loadmodule check", "install");
        }
        if (TouchEnNx.useModule.length > 0) {
            const TouchEnNxKeyInstall = setInterval(() => {
                TOUCHENEX_CHECK.check(TouchEnNx.useModule, result => {
                    if (result.status) {
                        clearInterval(TouchEnNxKeyInstall);
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                });
            }, 10);
        }
    })

    React.useEffect(() => {
        if (task === true) {
            loadingStore.increaseCount();
            checkTouchEnNx().then(isInstalled => {
                if (isInstalled) {
                    getTNKSR().then((result) => {
                        window["TNK_SR"] = result;
                        window["tekOption"].srdk = result;

                        if (window["loadflag"] === true) {
                            // @ts-ignore
                            window.TK_Rescan()
                        } else {
                            // @ts-ignore
                            window.TK_Loading()
                        }
                    }).catch((err) => {
                        alert(err);
                    }); // makeRndValue.jsp 기능 대처
                } else {
                    UIUtil.alert(<>
                        고객님의 안전한 거래를 위하여<br/>보안프로그램 설치가 필요합니다.<br/>[확인]을 선택하시면 설치페이지로 연결됩니다.
                    </>).then(() => {
                        history.push(touchenexInfo.tkInstallpage);
                    })
                }
                loadingStore.decreaseCount();
            })
        }
    }, [task])

    return (
        <PasswordContext.Provider value={task}>
            <PasswordDispatchContext.Provider value={dispatch}>
                <Suspense fallback={<PageLoading/>}>
                    {children}
                </Suspense>
            </PasswordDispatchContext.Provider>
        </PasswordContext.Provider>
    )
}

export function usePassword() {
    return React.useContext(PasswordContext);
}

export function usePasswordDispatch() {
    return React.useContext(PasswordDispatchContext);
}


function tasksReducer(tasks: boolean, action: boolean) {
    return action;
}

